import React, { useContext, useState, useEffect } from 'react'

import styles from './Requisito.module.css'
import Subtitle from '../../components/Subtitle/Subtitle'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import moment from 'moment'
import Modal from '../../components/Modals'
//Context
import GeneralContext from '../../context/GeneralContext'
import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'

//Services
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker, { utils } from "@hassanmojab/react-modern-calendar-datepicker"
import * as GeneralActions from '../../store/actions/generalActions'
import * as RequisitoRepository from "../../services/repositories/requisito-repository"

import RequisitosCard from './components/RequisitosCard'

const Requisito = ({ history }) => {
    const initialState = {
        estaCargando: true,
        errorCargando: null,
        estaCargandoProvincias: false,
        estaCargandoCentrosMedicos: false,
        requisito: {},
        requisitoAdicional: {},
        centroMedicoSeleccionado: null,
        centroMedicoSeleccionadoAdicional: null, 
        usarDireccionAsegurado: false,
        reloadValidacion: false,
        campoValidado: {
            departamento: true,
            provincia: true,
            centroMedico: true,
            fecha: true,
            hora: true,
            direccion: true
        },
        tipo: null,
        medicos: [],
        noMedicos: [],
        bloqueaDireccion: false,
        esAseguradoAdicional: false,
        tipoAdicional: null,
        medicosAdicional: [],
        noMedicosAdicional: [],
        bloqueaDireccionAdicional: false,
        campoValidadoAdicional: {
            departamento: true,
            provincia: true,
            centroMedico: true,
            fecha: true,
            hora: true,
            direccion: true
        },

        estaCargandoProvinciasAdicional: false,
        estaCargandoCentrosMedicosAdicional: false,
        usarDireccionAseguradoAdicional: false,
    }

    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter((user) => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(
        (prospecto) => prospecto.isSelected || prospecto.completado
    )[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const [state, setState] = useState(initialState)
    const [departamentos, setDepartamentos] = useState([])
    const [provincias, setProvincias] = useState([])
    const [centrosMedico, setCentrosMedico] = useState([])

    const [departamentosAdicional, setDepartamentosAdicional] = useState([])
    const [provinciasAdicional, setProvinciasAdicional] = useState([])
    const [centrosMedicoAdicional, setCentrosMedicoAdicional] = useState([])

    let fechaPrueba = state.requisito !== undefined && state.requisito !== null ? state.requisito.fecha : null
    const [inputDate, setInputDate] = useState(fechaPrueba)
    const [dia, setDia] = useState()

    const [tap, setTap] = useState(1)

    let fechaPruebaAdicional = state.requisitoAdicional !== undefined && state.requisitoAdicional !== null ? state.requisitoAdicional.fecha : null
    const [inputDateAdicional, setInputDateAdicional] = useState(fechaPruebaAdicional)
    const [diaAdicional, setDiaAdicional] = useState()



    const requisitosMedicosAdicional = async () => {
        
        
        setTap(2)
    }

    const obtenerCentrosMedicosInicialesAdicional = async (codDepartamento, codProvincia) => {
        const resCentrosMedicos = await RequisitoRepository.obtenerCentrosMedicos(codDepartamento, codProvincia)
        if (resCentrosMedicos.error === null) {
            setCentrosMedicoAdicional(resCentrosMedicos.centros)
            generalDispatch(GeneralActions.updateEstadoCargando(false))
        } else {
            generalDispatch(GeneralActions.updateError(resCentrosMedicos.error, '¡Alerta!'))
        }
    }

    const obtenerProvinciasInicialesAdicional = async (codDepartamento, codProvincia) => {
        const resProvincias = await RequisitoRepository.obtenerProvincias(codDepartamento)
        if (resProvincias.error === null) {
            setProvinciasAdicional(resProvincias.provincias)
            if (codProvincia !== undefined && codProvincia !== null) {
                obtenerCentrosMedicosInicialesAdicional(codDepartamento, codProvincia)
            } else {
                generalDispatch(GeneralActions.updateEstadoCargando(false))
            }
        } else {
            generalDispatch(GeneralActions.updateError(resProvincias.error, '¡Alerta!', true))
        }
    }

    const obtenerRequisitosAdicional = async () => {
            
        const resRequisitos = await RequisitoRepository.obtenerRequisitosAdicional(cotizacion.idSolicitudMultiple)
        
        if (resRequisitos.error === null) {
            if (resRequisitos.requisitos.centroMedico !== null && resRequisitos.requisitos.centroMedico !== undefined) {
                if (resRequisitos.requisitos.centroMedico.departamento !== undefined &&
                    resRequisitos.requisitos.centroMedico.departamento !== null) {
                    obtenerProvinciasInicialesAdicional(resRequisitos.requisitos.centroMedico.departamento.codigo, resRequisitos.requisitos.centroMedico.provincia.codigo)
                }
            } else {
                generalDispatch(GeneralActions.updateEstadoCargando(false))
            }
            setState((state) => {
                return {
                    ...state,
                    requisitoAdicional: {
                        ...resRequisitos.requisitos,
                        fecha: resRequisitos.requisitos.fecha !== null ? resRequisitos.requisitos.fecha.slice(0, -9) : null
                    },
                    medicosAdicional: obtenerListadoRequisitos(resRequisitos.requisitos.examenes, 1),
                    noMedicosAdicional: obtenerListadoRequisitos(resRequisitos.requisitos.examenes),
                    tipoAdicional: obtenerTipo(obtenerListadoRequisitos(resRequisitos.requisitos.examenes, 1), obtenerListadoRequisitos(resRequisitos.requisitos.examenes)),
                    bloqueaDireccionAdicional: resRequisitos.requisitos.centroMedico !== null && resRequisitos.requisitos.centroMedico.atencionDomicilio ? false : true 
                }
            })
        } else {
            setState((state) => {
                return {
                    ...state,
                    requisitoAdicional: null
                }
            })
            generalDispatch(GeneralActions.updateError(resRequisitos.error, '¡Alerta!', true))
        }
    }

    useEffect(() => {
        if (fechaPrueba !== '') {
            setInputDate(fechaPrueba)
        } else {
            setInputDate('')
        }
    }, [fechaPrueba])

    const onChangeInputDate = (valor) => {
        let fechaP = Funciones.transformarDatePickerToFecha(valor)

        let dias = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"]
        let dato = new Date(fechaP.setDate(fechaP.getDate()))
        let dia = dias[dato.getDay() === 0 ? 6 : (dato.getDay() - 1)]
        setDia(dia)

        /*Se agrega validacion para no ingresar fecha de cita los domingos*/
        if ((dia !== null && dia !== undefined && dia) === 'Sábado') {
            mostrarPopup2()
            setInputDate(valor)
            handleChangeFecha(valor, 'fecha')
        } else if ((dia !== null && dia !== undefined && dia) === 'Domingo') {
            mostrarPopup3()
        } else {
            setInputDate(valor)
            handleChangeFecha(valor, 'fecha')
        }
    }

    const onChangeInputDateAdicional = (valor) => {
        let fechaP = Funciones.transformarDatePickerToFecha(valor)

        let dias = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"]
        let dato = new Date(fechaP.setDate(fechaP.getDate()))
        let dia = dias[dato.getDay() === 0 ? 6 : (dato.getDay() - 1)]
        setDiaAdicional(dia)

        /*Se agrega validacion para no ingresar fecha de cita los domingos*/
        if ((dia !== null && dia !== undefined && dia) === 'Sábado') {
            mostrarPopup2()
            setInputDateAdicional(valor)
            handleChangeFechaAdicional(valor, 'fecha')
        } else if ((dia !== null && dia !== undefined && dia) === 'Domingo') {
            mostrarPopup3()
        } else {
            setInputDateAdicional(valor)
            handleChangeFechaAdicional(valor, 'fecha')
        }
    }

    const textos = ['¡Alerta!', 'La hora ingresada no debe ser menor a la actual']
    const [mostrarModal, setModal] = useState(false)
    const mostrarPopup = () => {
        setModal(!mostrarModal)
    }

    const textos2 = ['¡Alerta!', 'Su cita será programada para el día Lunes. ¿Está de acuerdo?']
    const [mostrarModal2, setModal2] = useState(false)
    const mostrarPopup2 = () => {
        setModal2(true)
    }

    const textos3 = ['¡Alerta!', 'No se puede programar cita médica para el día Domingo']
    const [mostrarModal3, setModal3] = useState(false)
    const mostrarPopup3 = () => {
        setModal3(true)
    }

    const obtenerListadoRequisitos = (listaExamenes, tipo) => {
        let listaSalida = []
        

        if (listaExamenes.length > 0) {
            if (tipo !== undefined) {
                let requisitos = listaExamenes.filter(exa => parseInt(exa.codigoCategoriaRequisito) === tipo)

                if (requisitos !== undefined && requisitos !== null && requisitos.length > 0) {
                    for (let i = 0; i < requisitos.length; i++)
                        listaSalida.push(requisitos[i].descripcionRequisito)
                }
            } else {
                let requisitos = listaExamenes.filter(exa => parseInt(exa.codigoCategoriaRequisito) !== 1)

                if (requisitos !== undefined && requisitos !== null && requisitos.length > 0) {
                    for (let i = 0; i < requisitos.length; i++)
                        listaSalida.push(requisitos[i].descripcionRequisito)
                }
            }
        }

        let sinDuplicados = listaSalida.filter((item,index)=>{
            return listaSalida.indexOf(item) === index;
        })

        return sinDuplicados
    }

    useEffect(() => {
        const cargarDepartamentos = async () => {
            const resDepartamentos = await RequisitoRepository.obtenerDepartamentos()
            if (resDepartamentos.error === null) {
                setDepartamentos(resDepartamentos.departamentos)
                setDepartamentosAdicional(resDepartamentos.departamentos)
                obtenerRequisitos()

                let esAseguradoAdicional = false
                cotizacion.solicitudes.map(solicitud => {
                    esAseguradoAdicional = solicitud.indicadorAseguradoAdicional
                })

                if(esAseguradoAdicional){
                    obtenerRequisitosAdicional()
                }

            } else {
                setState((state) => {
                    return {
                        ...state,
                        requisito: null,
                        requisitoAdicional: null
                    }
                })
                generalDispatch(GeneralActions.updateError(resDepartamentos.error, '¡Alerta!', true))
            }
        }

        const obtenerRequisitos = async () => {
            const resRequisitos = await RequisitoRepository.obtenerRequisitos(cotizacion.idSolicitudMultiple)
            if (resRequisitos.error === null) {
                if (resRequisitos.requisitos.centroMedico !== null && resRequisitos.requisitos.centroMedico !== undefined) {
                    if (resRequisitos.requisitos.centroMedico.departamento !== undefined &&
                        resRequisitos.requisitos.centroMedico.departamento !== null) {
                        obtenerProvinciasIniciales(resRequisitos.requisitos.centroMedico.departamento.codigo,
                            resRequisitos.requisitos.centroMedico.provincia.codigo)
                    }
                } else {
                    generalDispatch(GeneralActions.updateEstadoCargando(false))
                }
                setState((state) => {
                    return {
                        ...state,
                        requisito: {
                            ...resRequisitos.requisitos,
                            fecha: resRequisitos.requisitos.fecha !== null ? resRequisitos.requisitos.fecha.slice(0, -9) : null
                        },
                        medicos: obtenerListadoRequisitos(resRequisitos.requisitos.examenes, 1),
                        noMedicos: obtenerListadoRequisitos(resRequisitos.requisitos.examenes),
                        tipo: obtenerTipo(obtenerListadoRequisitos(resRequisitos.requisitos.examenes, 1), obtenerListadoRequisitos(resRequisitos.requisitos.examenes)),
                        bloqueaDireccion: resRequisitos.requisitos.centroMedico !== null && resRequisitos.requisitos.centroMedico.atencionDomicilio ? false : true 
                    }
                })
            } else {
                setState((state) => {
                    return {
                        ...state,
                        requisito: null
                    }
                })
                generalDispatch(GeneralActions.updateError(resRequisitos.error, '¡Alerta!', true))
            }
        }

        const obtenerProvinciasIniciales = async (codDepartamento, codProvincia) => {
            const resProvincias = await RequisitoRepository.obtenerProvincias(codDepartamento)
            if (resProvincias.error === null) {
                setProvincias(resProvincias.provincias)
                if (codProvincia !== undefined && codProvincia !== null) {
                    obtenerCentrosMedicosIniciales(codDepartamento, codProvincia)
                } else {
                    generalDispatch(GeneralActions.updateEstadoCargando(false))
                }
            } else {
                generalDispatch(GeneralActions.updateError(resProvincias.error, '¡Alerta!', true))
            }
        }

        const obtenerCentrosMedicosIniciales = async (codDepartamento, codProvincia) => {
            const resCentrosMedicos = await RequisitoRepository.obtenerCentrosMedicos(codDepartamento, codProvincia)
            if (resCentrosMedicos.error === null) {
                setCentrosMedico(resCentrosMedicos.centros)
                generalDispatch(GeneralActions.updateEstadoCargando(false))
            } else {
                generalDispatch(GeneralActions.updateError(resCentrosMedicos.error, '¡Alerta!'))
            }
        }

        const flagEsAseguradoAdicional = async () => {
            let esAseguradoAdicional = false
            cotizacion.solicitudes.map(solicitud => {
                esAseguradoAdicional = solicitud.indicadorAseguradoAdicional
            })
            setState((state) => {
                return {
                    ...state,
                    esAseguradoAdicional: esAseguradoAdicional
                }
            })
        }

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        cargarDepartamentos()
        flagEsAseguradoAdicional()
    }, [])

    const obtenerTipo = (medicos, noMedicos) => {
        let tipo = null
        if (medicos.length > 0 && noMedicos.length > 0) {
            tipo = 1
        } else if (medicos.length > 0) {
            tipo = 2
        } else if (noMedicos.length > 0) {
            tipo = 3
        }

        return tipo
    }

    const handleChangeCombo = (centroM, campo) => {
        let codigo = centroM.id
        let descripcion = centroM.descripcion

        setState((state) => {
            return {
                ...state,
                requisito: {
                    ...state.requisito,
                    [campo]: {
                        ...state.requisito[campo],
                        id: parseInt(codigo),
                        descripcion: descripcion
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                },
                bloqueaDireccion: centroM.atencionDomicilio ? false : true
            }
        })
    }

    const handleChangeComboAdicional = (centroM, campo) => {
        let codigo = centroM.id
        let descripcion = centroM.descripcion

        setState((state) => {
            return {
                ...state,
                requisitoAdicional: {
                    ...state.requisitoAdicional,
                    [campo]: {
                        ...state.requisitoAdicional[campo],
                        id: parseInt(codigo),
                        descripcion: descripcion
                    }
                },
                campoValidadoAdicional: {
                    ...state.campoValidadoAdicional,
                    [campo]: true
                },
                bloqueaDireccionAdicional: centroM.atencionDomicilio ? false : true
            }
        })
    }

    const handleChangeFecha = (event, campo) => {
        let valor = event

        setState((state) => {
            return {
                ...state,
                requisito: {
                    ...state.requisito,
                    [campo]: Funciones.transformarDatePickerToFecha(valor)//Funciones.formatearFechaP(Funciones.transformarDatePickerToFecha(valor))
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleChangeFechaAdicional = (event, campo) => {
        let valor = event

        setState((state) => {
            return {
                ...state,
                requisitoAdicional: {
                    ...state.requisitoAdicional,
                    [campo]: Funciones.transformarDatePickerToFecha(valor)//Funciones.formatearFechaP(Funciones.transformarDatePickerToFecha(valor))
                },
                campoValidadoAdicional: {
                    ...state.campoValidadoAdicional,
                    [campo]: true
                }
            }
        })
    }

    const cambiarFecha = () => {
        let fecha = new Date(state.requisito.fecha)
        let dato = ''
        if ((dia !== null && dia !== undefined && dia) === 'Viernes') {
            dato = new Date(fecha.setDate(fecha.getDate() + 3))
        } else if ((dia !== null && dia !== undefined && dia) === 'Sábado') {
            dato = new Date(fecha.setDate(fecha.getDate() + 2))
        }

        setState((state) => {
            return {
                ...state,
                requisito: {
                    ...state.requisito,
                    fecha: Funciones.formatearFechaP(dato)
                }
            }
        })
    }

    const handleChangeCualquierTexto = (event, valor, campo) => {
        let valorAux = valor !== null ? valor : event !== null ? event.target.value : ''

        if (campo === 'hora') {
            let hora = parseInt(valorAux.substr(-20, 2))
            let minuto = parseInt(valorAux.substr(-2))
            if ((dia !== null && dia !== undefined && dia) === 'Viernes' && hora > 16) {
                if (minuto === 0) {
                    mostrarPopup2()
                } else if (minuto > 0) {
                    mostrarPopup2()
                }
            } else if ((dia !== null && dia !== undefined && dia) === 'Viernes' && hora === 16 && minuto > 0) {
                mostrarPopup2()
            }
        }

        let capital = ""//Funciones.mostrarCamelCase(valorAux)

        setState((state) => {
            return {
                ...state,
                requisito: {
                    ...state.requisito,
                    [campo]: valorAux,
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleChangeCualquierTextoAdicional = (event, valor, campo) => {
        let valorAux = valor !== null ? valor : event !== null ? event.target.value : ''

        if (campo === 'hora') {
            let hora = parseInt(valorAux.substr(-20, 2))
            let minuto = parseInt(valorAux.substr(-2))
            if ((dia !== null && dia !== undefined && dia) === 'Viernes' && hora > 16) {
                if (minuto === 0) {
                    mostrarPopup2()
                } else if (minuto > 0) {
                    mostrarPopup2()
                }
            } else if ((dia !== null && dia !== undefined && dia) === 'Viernes' && hora === 16 && minuto > 0) {
                mostrarPopup2()
            }
        }

        let capital = ""//Funciones.mostrarCamelCase(valorAux)

        setState((state) => {
            return {
                ...state,
                requisitoAdicional: {
                    ...state.requisitoAdicional,
                    [campo]: valorAux,
                },
                campoValidadoAdicional: {
                    ...state.campoValidadoAdicional,
                    [campo]: true
                }
            }
        })
    }


    const handleChangeDepartamento = async (event) => {
        let codigo = event.target.value
        let descripcion = event.target[event.target.selectedIndex].text

        setCentrosMedico([])

        setState((state) => {
            return {
                ...state,
                requisito: {
                    ...state.requisito,
                    centroMedico: {
                        departamento: {
                            codigo: parseInt(codigo),
                            descripcion: descripcion
                        }
                    },
                    direccion: null
                },
                centroMedicoSeleccionado: null,
                campoValidado: {
                    ...state.campoValidado,
                    departamento: true
                }
            }
        })

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        const resProvincias = await RequisitoRepository.obtenerProvincias(codigo)
        if (resProvincias.error === null) {
            setProvincias(resProvincias.provincias)
            generalDispatch(GeneralActions.updateEstadoCargando(false))
        } else {
            generalDispatch(GeneralActions.updateError(resProvincias.error, '¡Alerta!', true))
        }
    }

    const handleChangeDepartamentoAdicional = async (event) => {
        let codigo = event.target.value
        let descripcion = event.target[event.target.selectedIndex].text

        setCentrosMedicoAdicional([])

        setState((state) => {
            return {
                ...state,
                requisitoAdicional: {
                    ...state.requisitoAdicional,
                    centroMedico: {
                        departamento: {
                            codigo: parseInt(codigo),
                            descripcion: descripcion
                        }
                    },
                    direccion: null
                },
                centroMedicoSeleccionadoAdicional: null,
                campoValidadoAdicional: {
                    ...state.campoValidadoAdicional,
                    departamento: true
                }
            }
        })

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        const resProvincias = await RequisitoRepository.obtenerProvincias(codigo)
        if (resProvincias.error === null) {
            setProvinciasAdicional(resProvincias.provincias)
            generalDispatch(GeneralActions.updateEstadoCargando(false))
        } else {
            generalDispatch(GeneralActions.updateError(resProvincias.error, '¡Alerta!', true))
        }
    }

    const handleChangeProvinciaAdicional = async (event) => {
        let codigo = event.target.value
        let descripcion = event.target[event.target.selectedIndex].text

        setState((state) => {
            return {
                ...state,
                requisitoAdicional: {
                    ...state.requisitoAdicional,
                    centroMedico: {
                        ...state.requisitoAdicional.centroMedico,
                        provincia: {
                            codigo: parseInt(codigo),
                            descripcion: descripcion,
                        }
                    }
                },
                campoValidadoAdicional: {
                    ...state.campoValidado,
                    provincia: true
                }
            }
        })

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        const resCentrosMedicos = await RequisitoRepository.obtenerCentrosMedicos(state.requisitoAdicional.centroMedico.departamento.codigo,
            event.target.value)
        if (resCentrosMedicos.error === null) {
            setCentrosMedicoAdicional(resCentrosMedicos.centros)
            generalDispatch(GeneralActions.updateEstadoCargando(false))
        } else {
            generalDispatch(GeneralActions.updateError(resCentrosMedicos.error, '¡Alerta!', true))
        }
    }

    const handleChangeProvincia = async (event) => {
        let codigo = event.target.value
        let descripcion = event.target[event.target.selectedIndex].text

        setState((state) => {
            return {
                ...state,
                requisito: {
                    ...state.requisito,
                    centroMedico: {
                        ...state.requisito.centroMedico,
                        provincia: {
                            codigo: parseInt(codigo),
                            descripcion: descripcion,
                        }
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    provincia: true
                }
            }
        })

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        const resCentrosMedicos = await RequisitoRepository.obtenerCentrosMedicos(state.requisito.centroMedico.departamento.codigo,
            event.target.value)
        if (resCentrosMedicos.error === null) {
            setCentrosMedico(resCentrosMedicos.centros)
            generalDispatch(GeneralActions.updateEstadoCargando(false))
        } else {
            generalDispatch(GeneralActions.updateError(resCentrosMedicos.error, '¡Alerta!', true))
        }
    }

    const handleChangeCentroMedico = async (event) => {
        const centroMedico = centrosMedico.filter(
            (centroMedicoAux) => centroMedicoAux.id === parseInt(event.target.value)
        )[0]

        handleChangeCombo(centroMedico, 'centroMedico')

        setState((state) => {
            return {
                ...state,
                centroMedicoSeleccionado: centroMedico,
                usarDireccionAsegurado: false
            }
        })

        handleChangeCualquierTexto(null, centroMedico.direccion, 'direccion')
    }

    const handleChangeCentroMedicoAdicional = async (event) => {
        const centroMedico = centrosMedicoAdicional.filter(
            (centroMedicoAux) => centroMedicoAux.id === parseInt(event.target.value)
        )[0]

        handleChangeComboAdicional(centroMedico, 'centroMedico')

        setState((state) => {
            return {
                ...state,
                centroMedicoSeleccionadoAdicional: centroMedico,
                usarDireccionAseguradoAdicional: false
            }
        })

        handleChangeCualquierTextoAdicional(null, centroMedico.direccion, 'direccion')
    }

    const handleChangeRadioDireccion = async (event) => {
        let valor = event.currentTarget.checked
        setState((state) => {
            return {
                ...state,
                usarDireccionAsegurado: valor,
            }
        })

        if (valor) {
            handleChangeCualquierTexto(null, Funciones.mostrarCamelCase(cotizacion.asegurado.contacto.direccion), 'direccion')
        } else {
            handleChangeCualquierTexto(
                null,
                state.centroMedicoSeleccionado.direccion || '',
                'direccion'
            )
        }
    }

    const handleChangeRadioDireccionAdicional = async (event) => {
        let valor = event.currentTarget.checked
        setState((state) => {
            return {
                ...state,
                usarDireccionAseguradoAdicional: valor,
            }
        })

        if (valor) {
            handleChangeCualquierTextoAdicional(null, Funciones.mostrarCamelCase(cotizacion.asegurado.contacto.direccion), 'direccion')
        } else {
            handleChangeCualquierTexto(
                null,
                state.centroMedicoSeleccionadoAdicional.direccion || '',
                'direccion'
            )
        }
    }

    const validarFormularioAdicional = () => {
        let validado = true

        const asignarValidacionCampo = (campo, valor) => {
            validado = validado && valor
            setState((state) => {
                return {
                    ...state,
                    campoValidadoAdicional: {
                        ...state.campoValidadoAdicional,
                        [campo]: valor,
                    }
                }
            })
        }

        const validarCombo = (objeto, campoValidacion, campo) => {
            if (
                objeto === null ||
                objeto[campo] === null ||
                objeto[campo] === undefined ||
                objeto[campo].codigo === null ||
                objeto[campo].codigo === -1
            ) {
                asignarValidacionCampo(campoValidacion, false)
                setTap(2)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        const validarTexto = (objeto, campoValidacion, campo) => {
            if (
                objeto === null ||
                objeto[campo] === undefined ||
                objeto[campo] === null ||
                objeto[campo] === '' || objeto[campo] === '00:00'
            ) {
                asignarValidacionCampo(campoValidacion, false)
                setTap(2)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        const validarFecha = (objeto, campoValidacion, campo) => {
            if (objeto === null || objeto[campo] === undefined || objeto[campo] === null ||
                objeto[campo] === '' || !Funciones.esFechaPosterior(objeto[campo]) || objeto[campo] === '0001-01-01T00:00:00') {
                asignarValidacionCampo(campoValidacion, false)
                setTap(2)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        const validarhora = (objeto, campoValidacion, campo) => {
            if (comparacionFecha === 1 && horaMinima === true) {
                mostrarPopup()
                asignarValidacionCampo(campoValidacion, false)
                setTap(2)
            } else if (objeto[campo] === '00:00' || objeto[campo] === null) {
                asignarValidacionCampo(campoValidacion, false)
                setTap(2)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }
        
        if( state.medicosAdicional.length !== 0){
            validarCombo(state.requisitoAdicional.centroMedico, 'departamento', 'departamento')
            validarCombo(state.requisitoAdicional.centroMedico, 'provincia', 'provincia')
            validarCombo(state.requisitoAdicional, 'centroMedico', 'centroMedico')
            validarFecha(state.requisitoAdicional, 'fecha', 'fecha')
            validarTexto(state.requisitoAdicional, 'hora', 'hora')
            validarTexto(state.requisitoAdicional, 'direccion', 'direccion')
            validarhora(state.requisitoAdicional, 'hora', 'hora')
        }
        return validado
    }

    const validarFormulario = () => {
        let validado = true

        const asignarValidacionCampo = (campo, valor) => {
            validado = validado && valor
            setState((state) => {
                return {
                    ...state,
                    campoValidado: {
                        ...state.campoValidado,
                        [campo]: valor,
                    }
                }
            })
        }

        const validarCombo = (objeto, campoValidacion, campo) => {
            if (
                objeto === null ||
                objeto[campo] === null ||
                objeto[campo] === undefined ||
                objeto[campo].codigo === null ||
                objeto[campo].codigo === -1
            ) {
                asignarValidacionCampo(campoValidacion, false)
                setTap(1)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        const validarTexto = (objeto, campoValidacion, campo) => {
            if (
                objeto === null ||
                objeto[campo] === undefined ||
                objeto[campo] === null ||
                objeto[campo] === '' || objeto[campo] === '00:00'
            ) {
                asignarValidacionCampo(campoValidacion, false)
                setTap(1)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        const validarFecha = (objeto, campoValidacion, campo) => {
            if (objeto === null || objeto[campo] === undefined || objeto[campo] === null ||
                objeto[campo] === '' || !Funciones.esFechaPosterior(objeto[campo]) || objeto[campo] === '0001-01-01T00:00:00') {
                asignarValidacionCampo(campoValidacion, false)
                setTap(1)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        const validarhora = (objeto, campoValidacion, campo) => {
            if (comparacionFecha === 1 && horaMinima === true) {
                mostrarPopup()
                asignarValidacionCampo(campoValidacion, false)
                setTap(1)
            } else if (objeto[campo] === '00:00' || objeto[campo] === null) {
                asignarValidacionCampo(campoValidacion, false)
                setTap(1)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        if( state.medicos.length !== 0 ){
            validarCombo(state.requisito.centroMedico, 'departamento', 'departamento')
            validarCombo(state.requisito.centroMedico, 'provincia', 'provincia')
            validarCombo(state.requisito, 'centroMedico', 'centroMedico')
            validarFecha(state.requisito, 'fecha', 'fecha')
            validarTexto(state.requisito, 'hora', 'hora')
            validarTexto(state.requisito, 'direccion', 'direccion')
            validarhora(state.requisito, 'hora', 'hora')
        }

        return validado
    }

    const invocarPostRequisito = async () => {
        setState((state) => {
            return {
                ...state,
                estaCargando: true,
                errorCargando: null
            }
        })

        const requisitoAux = {
            codigoCentroMedico: state.requisito.centroMedico.codigo ? state.requisito.centroMedico.codigo : state.requisito.centroMedico.id,
            fecha: Funciones.formatearFecha(state.requisito.fecha),//state.requisito.fecha.slice(0, -9),
            hora: state.requisito.hora,
            direccion: state.requisito.direccion,
            usuario: user.info.IdUsuario
        }

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        const resRequisito = await RequisitoRepository.registrarAgendaCita(cotizacion.idSolicitudMultiple, requisitoAux)
        if (resRequisito.error === null) {
            generalDispatch(GeneralActions.updateEstadoCargando(false))
            return true
        } else {
            handleChangeCualquierTexto(null, resRequisito.direccion, 'direccion')
            return false
        }
    }

    const invocarPostRequisitoAdicional = async () => {
        setState((state) => {
            return {
                ...state,
                estaCargando: true,
                errorCargando: null
            }
        })

        const requisitoAux = {
            codigoCentroMedico: state.requisitoAdicional.centroMedico.codigo ? state.requisitoAdicional.centroMedico.codigo : state.requisitoAdicional.centroMedico.id,
            fecha: Funciones.formatearFecha(state.requisitoAdicional.fecha),//state.requisito.fecha.slice(0, -9),
            hora: state.requisitoAdicional.hora,
            direccion: state.requisitoAdicional.direccion,
            usuario: user.info.IdUsuario
        }

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        const resRequisito = await RequisitoRepository.registrarAgendaCitaAdicional(cotizacion.idSolicitudMultiple, requisitoAux)
        if (resRequisito.error === null) {
            generalDispatch(GeneralActions.updateEstadoCargando(false))
            return true
        } else {
            handleChangeCualquierTextoAdicional(null, resRequisito.direccion, 'direccion')
            return false
        }
    }

    const continuarToFirma = async () => {
        if (!state.esAseguradoAdicional && state.tipo === 3) {
            return true
        } else if (state.esAseguradoAdicional && state.tipo === 3 && state.tipoAdicional === 3){
            return true
        } else {
            if (!state.esAseguradoAdicional && validarFormulario()) {
                return await invocarPostRequisito()
            } else if (!state.esAseguradoAdicional && !validarFormulario()) {  
                return false
            } else {
                if(state.medicos.length !== 0 && state.medicosAdicional.length !== 0
                    && validarFormulario() && validarFormularioAdicional()
                ){
                    return await invocarPostRequisito() && await invocarPostRequisitoAdicional()
                } else if(state.medicos.length !== 0 && state.medicosAdicional.length === 0 
                    && validarFormulario()
                ){
                    return await invocarPostRequisito();
                } else if(state.medicos.length === 0 && state.medicosAdicional.length !== 0
                    && validarFormularioAdicional()
                ) {
                   return await invocarPostRequisitoAdicional()
                } else if(state.medicos.length === 0 && state.medicosAdicional.length === 0) {
                   return true  
                } else {
                   return false
                } 
            }
        }
    }

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true && complete !== undefined) {
            return true
        } else {
            return false
        }
    }

    let act = state.centroMedicoSeleccionado !== null && state.centroMedicoSeleccionado !== undefined ?
        state.centroMedicoSeleccionado.atencionDomicilio : ''

        
    let actAdicional = state.centroMedicoSeleccionadoAdicional !== null && state.centroMedicoSeleccionadoAdicional !== undefined ?
    state.centroMedicoSeleccionadoAdicional.atencionDomicilio : ''

    /*variables para las validaciones de la fecha y hora de la cita*/
    let hoy = new Date()
    let nuevoHoy = new Date(new Date().setDate(new Date().getDate() + 2))

    let comparacionFecha = moment(inputDate).format("YYYY-MM-DD") === moment(hoy).format("YYYY-MM-DD") ? 1 : 2
    let horaMarcada = state.requisito !== undefined && state.requisito !== null ? state.requisito.hora : null

    let horaActual = hoy.getHours() + ':' + hoy.getMinutes()
    let horaMinima = horaMarcada < horaActual ? true : false

    //INICIO-Utilitarios CampoFecha
    const myCustomLocale = {
        // months list by order
        months: [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Setiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
        ],

        // week days by order
        weekDays: [
            {
                name: 'Domingo', // used for accessibility 
                short: 'D', // displayed at the top of days' rows
                isWeekend: true, // is it a formal weekend or not?
            },
            {
                name: 'Lunes',
                short: 'L',
            },
            {
                name: 'Martes',
                short: 'M',
            },
            {
                name: 'Miércoles',
                short: 'M',
            },
            {
                name: 'Jueves',
                short: 'J',
            },
            {
                name: 'Viernes',
                short: 'V',
            },
            {
                name: 'Sábado',
                short: 'S',
                isWeekend: true,
            }
        ],

        // just play around with this number between 0 and 6
        weekStartingIndex: 0,

        // return a { year: number, month: number, day: number } object
        getToday(gregorainTodayObject) {
            return gregorainTodayObject;
        },

        // return a native JavaScript date here
        toNativeDate(date) {
            return new Date(date.year, date.month - 1, date.day);
        },

        // return a number for date's month length
        getMonthLength(date) {
            return new Date(date.year, date.month, 0).getDate();
        },

        // return a transformed digit to your locale
        transformDigit(digit) {
            return digit;
        },

        // texts in the date picker
        nextMonth: 'Next Month',
        previousMonth: 'Previous Month',
        openMonthSelector: 'Open Month Selector',
        openYearSelector: 'Open Year Selector',
        closeMonthSelector: 'Close Month Selector',
        closeYearSelector: 'Close Year Selector',
        defaultPlaceholder: 'Select...',

        // for input range value
        from: 'from',
        to: 'to',


        // used for input value when multi dates are selected
        digitSeparator: ',',

        // if your provide -2 for example, year will be 2 digited
        yearLetterSkip: 0,

        // is your language rtl or ltr?
        isRtl: false,
    }

    const obtenerFormatoFecha = () => {
        const valor = (state.requisito && state.requisito.fecha !== null) ?
                Funciones.transformarFechaToDatePicker(state.requisito.fecha) : ''

        if (!valor) return ''
        return `${valor.day}/${valor.month}/${valor.year}`
    }

    const obtenerFormatoFechaAdicional = () => {
        const valor = (state.requisitoAdicional && state.requisitoAdicional.fecha !== null) ?
                Funciones.transformarFechaToDatePicker(state.requisitoAdicional.fecha) : ''

        if (!valor) return ''
        return `${valor.day}/${valor.month}/${valor.year}`
    }
    //FIN-Utilitarios campo Fecha

    return (
        <div>
            <Header history={history} />
            <section className={styles['areadatosusuario']}>
                <h1 className={styles['titulo']}>
                    Tenemos algunos requisitos iniciales para proceder con su solicitud
                </h1>


                {
                    state.esAseguradoAdicional ?
                        <div>
                            <div className={styles['tabsSeleccionarAsegurado']}>
                                <div className={ tap === 1 ? styles['tabsSeleccionarAseguradoSelec'] : null}>
                                    <a onClick={() => setTap(1) }>Asegurado Principal</a>
                                </div>
                                <div className={ tap === 2 ? styles['tabsSeleccionarAseguradoSelec'] : null}>
                                    <a onClick={() => requisitosMedicosAdicional()} >Asegurado Adicional</a>
                                </div>
                            </div>	
                            <br/><br/>
                        </div>
                    : null
                }

                
                {
					tap === 1 ?

                        <div className={styles['areadatosprospecto']}>
                            <Subtitle sname='Evaluación' />
                            <p className={styles['areadatosprospecto__subtitulo_info']}>
                                Vamos a necesitar los siguientes análisis o pruebas:
                            </p>
                            <RequisitosCard medicos={state.medicos} noMedicos={state.noMedicos} caso={state.tipo} />
                            <p className={styles['txtrequisito']}>
                                {state.tipo === 1 || state.tipo === 2 ?
                                    'Por requerir un examen médico, necesitamos que elijas una fecha y una hora para agendar tu cita. Nos pondremos en contacto contigo para confirmarla.'
                                    : state.tipo === 3 ?
                                        'Te llegará un correo para que envíes la información requerida.' : null
                                }
                            </p>
                            {state.tipo === 1 || state.tipo === 2 ?
                                <div>
                                    <div className={styles['contenedor2']}>
                                        <div className={styles['caja-1']}>
                                            <label>Departamento</label>
                                            <select
                                                className={
                                                    !state.campoValidado.departamento
                                                        ? `${styles['logerror']} ${styles['departamento']}`
                                                        : styles['departamento']
                                                }
                                                value={
                                                    state.requisito !== null &&
                                                        state.requisito.centroMedico !== undefined &&
                                                        state.requisito.centroMedico !== null &&
                                                        state.requisito.centroMedico.departamento !== undefined
                                                        ? state.requisito.centroMedico.departamento.codigo
                                                        : ''
                                                }
                                                onChange={handleChangeDepartamento}
                                                disabled={Deshabilitar() !== true ? false : true} >
                                                <option value={-1}>Seleccione</option>
                                                {departamentos.map((departamento) => (
                                                    <option key={departamento.codigo} value={departamento.codigo}>
                                                        {departamento.descripcion}
                                                    </option>
                                                ))}
                                            </select>
                                            {!state.campoValidado.departamento && (
                                                <span className={styles['span-error']}>
                                                    {Constantes.MENSAJE_VALIDACION_DEPARTAMENTO}
                                                </span>
                                            )}
                                        </div>
                                        <div className={styles['caja-2']}>
                                            <label>Provincia</label>
                                            <select
                                                className={!state.campoValidado.provincia ?
                                                    `${styles['logerror']} ${styles['provincia']}` : styles['provincia']
                                                }
                                                value={
                                                    state.requisito !== null &&
                                                        state.requisito.centroMedico !== undefined &&
                                                        state.requisito.centroMedico !== null &&
                                                        state.requisito.centroMedico.provincia !== undefined
                                                        ? state.requisito.centroMedico.provincia.codigo
                                                        : ''
                                                }
                                                onChange={handleChangeProvincia}
                                                disabled={Deshabilitar() !== true ? state.estaCargandoProvincias : true} >
                                                <option value={-1}>Seleccione</option>
                                                {provincias.map((provincia) => (
                                                    <option key={provincia.codigo} value={provincia.codigo}>
                                                        {provincia.descripcion}
                                                    </option>
                                                ))}
                                            </select>
                                            {!state.campoValidado.provincia && (
                                                <span className={styles['span-error']}>
                                                    {Constantes.MENSAJE_VALIDACION_PROVINCIA}
                                                </span>
                                            )}
                                        </div>
                                        <div className={styles['caja-3']}>
                                            <label>Centro Médico</label>
                                            <select
                                                className={!state.campoValidado.centroMedico ?
                                                    `${styles['logerror']} ${styles['centro-medico']}` : styles['centro-medico']
                                                }
                                                value={
                                                    state.requisito !== null &&
                                                        state.requisito.centroMedico !== undefined &&
                                                        state.requisito.centroMedico !== null
                                                        ? state.requisito.centroMedico.id
                                                        : -1
                                                }
                                                onChange={handleChangeCentroMedico}
                                                disabled={Deshabilitar() !== true ? state.estaCargandoCentrosMedicos : true} >
                                                <option value={-1}>Seleccione</option>
                                                {centrosMedico.map((centroMedico) => (
                                                    <option key={centroMedico.id} value={centroMedico.id}>
                                                        {centroMedico.descripcion}
                                                    </option>
                                                ))}
                                            </select>
                                            {!state.campoValidado.centroMedico && (
                                                <span className={styles['span-error']}>
                                                    {Constantes.MENSAJE_VALIDACION_CENTRO_MEDICO}
                                                </span>
                                            )}
                                        </div>
                                        {/*Nuevo campo fecha sin utilizar el componente */}
                                        <div className={!state.campoValidado.fecha ? styles['caja5'] : Deshabilitar() ? styles['caja7']
                                            : styles['caja-4']}>
                                            <label>Fecha de la Cita</label>
                                            <DatePicker
                                                minimumDate={(new Date().getHours() >= 16 && new Date().getMinutes() > 1)
                                                    ? Funciones.transformarFechaToDatePicker(nuevoHoy) : utils().getToday()}
                                                value={(state.requisito && state.requisito.fecha !== null) ?
                                                    Funciones.transformarFechaToDatePicker(state.requisito.fecha) : null}
                                                onChange={(value) => onChangeInputDate(value)}
                                                shouldHighlightWeekends
                                                colorPrimary="#0fbcf9"
                                                calendarClassName="responsive-calendar"
                                                calendarPopperPosition="bottom"
                                                inputPlaceholder="DD/MM/AAAA"
                                                formatInputText={obtenerFormatoFecha}
                                                disabled={false}
                                                locale={myCustomLocale}
                                            />
                                            {(!state.campoValidado.fecha && (state.requisito.fecha === "0001-01-01T00:00:00" ||
                                                state.requisito.fecha === null)) ? (
                                                <span className={styles['span-error']}>
                                                    {Constantes.MENSAJE_VALIDACION_FECHA}
                                                </span>)
                                                : null
                                            }
                                        </div>
                                    </div>
                                    <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                                        <div className={styles['area22']}>
                                            <label>Hora de la Cita</label>
                                            <input
                                                type='time'
                                                value={state.requisito && (state.requisito.hora === '00:00' || state.requisito.hora === null)
                                                    ? '' : state.requisito.hora}
                                                className={!state.campoValidado.hora ? styles['logerror'] : null}
                                                onChange={(e) => handleChangeCualquierTexto(e, null, 'hora')}
                                                disabled={Deshabilitar() !== true ? false : true}
                                            />
                                            {!state.campoValidado.hora && (
                                                <span className={styles['span-error']}>
                                                    {Constantes.MENSAJE_VALIDACION_HORA}
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    {act ?
                                        <div className={styles['areaseleccion']}>
                                            <input
                                                type='checkbox'
                                                className={styles.check_box}
                                                onChange={handleChangeRadioDireccion}
                                                disabled={Deshabilitar() !== true ? false : true}
                                            />
                                            <span>Usar la dirección del propuesto asegurado.</span>
                                        </div>
                                        : null}
                                    <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                                        <div className={styles['area100']}>
                                            <label>Dirección</label>
                                            <input
                                                style={{ paddingLeft: "1%" }}
                                                type='text'
                                                value={state.requisito.direccion || ''}
                                                className={!state.campoValidado.direccion ? styles['logerror'] : null}
                                                onChange={(e) => handleChangeCualquierTexto(e, null, 'direccion')}
                                                disabled={Deshabilitar() === true || state.bloqueaDireccion ? true : false}
                                            />
                                            {!state.campoValidado.direccion && (
                                                <span className={styles['span-error']}>
                                                    {Constantes.MENSAJE_VALIDACION_DIRECCION}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                : null
                            }

                        </div>

                    : 
                        <div className={styles['areadatosprospecto']}>
                            <Subtitle sname='Evaluación' />
                            <p className={styles['areadatosprospecto__subtitulo_info']}>
                                Vamos a necesitar los siguientes análisis o pruebas:
                            </p>
                            <RequisitosCard medicos={state.medicosAdicional} noMedicos={state.noMedicosAdicional} caso={state.tipoAdicional} />
                            <p className={styles['txtrequisito']}>
                                {state.tipoAdicional === 1 || state.tipoAdicional === 2 ?
                                    'Por requerir un examen médico, necesitamos que elijas una fecha y una hora para agendar tu cita. Nos pondremos en contacto contigo para confirmarla.'
                                    : state.tipo === 3 ?
                                        'Te llegará un correo para que envíes la información requerida.' : null
                                }
                            </p>
                            
                            {state.tipoAdicional === 1 || state.tipoAdicional === 2 ?
                                <div>
                                    <div className={styles['contenedor2']}>
                                        <div className={styles['caja-1']}>
                                            <label>Departamento</label>
                                            <select
                                                className={ !state.campoValidadoAdicional.departamento  ? `${styles['logerror']} ${styles['departamento']}` : styles['departamento']}
                                                value={
                                                    state.requisitoAdicional !== null &&
                                                        state.requisitoAdicional.centroMedico !== undefined &&
                                                        state.requisitoAdicional.centroMedico !== null &&
                                                        state.requisitoAdicional.centroMedico.departamento !== undefined
                                                        ? state.requisitoAdicional.centroMedico.departamento.codigo
                                                        : ''
                                                }
                                                onChange={handleChangeDepartamentoAdicional}
                                                disabled={Deshabilitar() !== true ? false : true} >
                                                <option value={-1}>Seleccione</option>
                                                {departamentosAdicional.map((departamento) => (
                                                    <option key={departamento.codigo} value={departamento.codigo}>
                                                        {departamento.descripcion}
                                                    </option>
                                                ))}
                                            </select>
                                            {!state.campoValidadoAdicional.departamento && (
                                                <span className={styles['span-error']}>
                                                    {Constantes.MENSAJE_VALIDACION_DEPARTAMENTO}
                                                </span>
                                            )}
                                        </div>
                                        <div className={styles['caja-2']}>
                                            <label>Provincia</label>
                                            <select
                                                className={!state.campoValidadoAdicional.provincia ? `${styles['logerror']} ${styles['provincia']}` : styles['provincia'] }
                                                value={
                                                    state.requisitoAdicional !== null &&
                                                        state.requisitoAdicional.centroMedico !== undefined &&
                                                        state.requisitoAdicional.centroMedico !== null &&
                                                        state.requisitoAdicional.centroMedico.provincia !== undefined
                                                        ? state.requisitoAdicional.centroMedico.provincia.codigo
                                                        : ''
                                                }
                                                onChange={handleChangeProvinciaAdicional}
                                                disabled={Deshabilitar() !== true ? state.estaCargandoProvinciasAdicional : true} >
                                                <option value={-1}>Seleccione</option>
                                                {provinciasAdicional.map((provincia) => (
                                                    <option key={provincia.codigo} value={provincia.codigo}>
                                                        {provincia.descripcion}
                                                    </option>
                                                ))}
                                            </select>
                                            {!state.campoValidadoAdicional.provincia && (
                                                <span className={styles['span-error']}>
                                                    {Constantes.MENSAJE_VALIDACION_PROVINCIA}
                                                </span>
                                            )}
                                        </div>
                                        <div className={styles['caja-3']}>
                                            <label>Centro Médico</label>
                                            <select
                                                className={!state.campoValidadoAdicional.centroMedico ?
                                                    `${styles['logerror']} ${styles['centro-medico']}` : styles['centro-medico']
                                                }
                                                value={
                                                    state.requisitoAdicional !== null &&
                                                        state.requisitoAdicional.centroMedico !== undefined &&
                                                        state.requisitoAdicional.centroMedico !== null
                                                        ? state.requisitoAdicional.centroMedico.id
                                                        : -1
                                                }
                                                onChange={handleChangeCentroMedicoAdicional}
                                                disabled={Deshabilitar() !== true ? state.estaCargandoCentrosMedicosAdicional : true} >
                                                <option value={-1}>Seleccione</option>
                                                {centrosMedicoAdicional.map((centroMedico) => (
                                                    <option key={centroMedico.id} value={centroMedico.id}>
                                                        {centroMedico.descripcion}
                                                    </option>
                                                ))}
                                            </select>
                                            {!state.campoValidadoAdicional.centroMedico && (
                                                <span className={styles['span-error']}>
                                                    {Constantes.MENSAJE_VALIDACION_CENTRO_MEDICO}
                                                </span>
                                            )}
                                        </div>
                                        {/*Nuevo campo fecha sin utilizar el componente */}
                                        <div className={!state.campoValidadoAdicional.fecha ? styles['caja5'] : Deshabilitar() ? styles['caja7']
                                            : styles['caja-4']}>
                                            <label>Fecha de la Cita</label>
                                            <DatePicker
                                                minimumDate={(new Date().getHours() >= 16 && new Date().getMinutes() > 1)
                                                    ? Funciones.transformarFechaToDatePicker(nuevoHoy) : utils().getToday()}
                                                value={(state.requisitoAdicional && state.requisitoAdicional.fecha !== null) ?
                                                    Funciones.transformarFechaToDatePicker(state.requisitoAdicional.fecha) : null}
                                                onChange={(value) => onChangeInputDateAdicional(value)}
                                                shouldHighlightWeekends
                                                colorPrimary="#0fbcf9"
                                                calendarClassName="responsive-calendar"
                                                calendarPopperPosition="bottom"
                                                inputPlaceholder="DD/MM/AAAA"
                                                formatInputText={obtenerFormatoFechaAdicional}
                                                disabled={false}
                                                locale={myCustomLocale}
                                            />
                                            {(!state.campoValidadoAdicional.fecha && (state.requisitoAdicional.fecha === "0001-01-01T00:00:00" ||
                                                state.requisitoAdicional.fecha === null)) ? (
                                                <span className={styles['span-error']}>
                                                    {Constantes.MENSAJE_VALIDACION_FECHA}
                                                </span>)
                                                : null
                                            }
                                        </div>
                                    </div>
                                    <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                                        <div className={styles['area22']}>
                                            <label>Hora de la Cita</label>
                                            <input
                                                type='time'
                                                value={state.requisitoAdicional && (state.requisitoAdicional.hora === '00:00' || state.requisitoAdicional.hora === null)
                                                    ? '' : state.requisitoAdicional.hora}
                                                className={!state.campoValidadoAdicional.hora ? styles['logerror'] : null}
                                                onChange={(e) => handleChangeCualquierTextoAdicional(e, null, 'hora')}
                                                disabled={Deshabilitar() !== true ? false : true}
                                            />
                                            {!state.campoValidadoAdicional.hora && (
                                                <span className={styles['span-error']}>
                                                    {Constantes.MENSAJE_VALIDACION_HORA}
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    {actAdicional ?
                                        <div className={styles['areaseleccion']}>
                                            <input
                                                type='checkbox'
                                                className={styles.check_box}
                                                onChange={handleChangeRadioDireccionAdicional}
                                                disabled={Deshabilitar() !== true ? false : true}
                                            />
                                            <span>Usar la dirección del propuesto asegurado.</span>
                                        </div>
                                        : null}
                                    <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                                        <div className={styles['area100']}>
                                            <label>Dirección</label>
                                            <input
                                                style={{ paddingLeft: "1%" }}
                                                type='text'
                                                value={state.requisitoAdicional.direccion || ''}
                                                className={!state.campoValidadoAdicional.direccion ? styles['logerror'] : null}
                                                onChange={(e) => handleChangeCualquierTextoAdicional(e, null, 'direccion')}
                                                disabled={Deshabilitar() === true || state.bloqueaDireccionAdicional ? true : false}
                                            />
                                            {!state.campoValidadoAdicional.direccion && (
                                                <span className={styles['span-error']}>
                                                    {Constantes.MENSAJE_VALIDACION_DIRECCION}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                : null
                            }
                        
                        </div>

                }

                <Modal mostrarModal={mostrarModal} setModal={setModal} textos={textos} />
                <Modal mostrarModal={mostrarModal2} setModal={setModal2} doble={true} textos={textos2} accion={() => cambiarFecha()} />
                <Modal mostrarModal={mostrarModal3} setModal={setModal3} textos={textos3} />
                <Footer history={history} validarPantalla={continuarToFirma} />
            </section>
        </div>
    )
}

export default Requisito
